import type * as THREE from 'three'
import { STRIKES, type AttackKind } from './simulation'

export type AttackClipWindow={start01:number;end01:number}
const WINDOWS:Record<AttackKind,AttackClipWindow>={
 light:{start01:.32,end01:.68},
 heavy:{start01:.25,end01:.95},
 special:{start01:.22,end01:.95},
 throw:{start01:.32,end01:.72},
}

export function attackClipWindow(kind:AttackKind):AttackClipWindow{
 return WINDOWS[kind]
}

export function attackTotalSeconds(kind:AttackKind){
 const strike=STRIKES[kind]
 return strike.startup+strike.active+strike.recovery
}

export function syncedAttackPlaybackRate(kind:AttackKind,clipDuration:number,baseRate=1){
 const {start01,end01}=attackClipWindow(kind)
 const total=Math.max(.001,attackTotalSeconds(kind))
 const raw=Math.max(.001,clipDuration)*(end01-start01)/total
 return Math.max(.75,Math.min(3.6,Math.max(baseRate,raw)))
}
export function isFightRuntimeAnimationClipSafe(clip:THREE.AnimationClip){
 if(!Number.isFinite(clip.duration)||clip.duration<0)return false
 const name=clip.name.toLowerCase()
 const attackLike=/attack|swing|slash|melee|combat|strike|smash|punch|kick/.test(name)
 if(attackLike&&clip.duration>4.25)return false
 for(const track of clip.tracks){
  const values=track.values
  for(let i=0;i<values.length;i++)if(!Number.isFinite(Number(values[i])))return false
 }
 return true
}
